import {
    Tooltip, TooltipProvider, TooltipTrigger
} from 'shared/components/ui/tooltip';
import KBTooltipContent from './KBTooltipContent';

export default function KBTooltipWrapper({
    children, icon, tooltipText
}) {
    return (
        <>
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>{children}</TooltipTrigger>
                    <KBTooltipContent tooltipText={tooltipText} icon={icon}/>
                </Tooltip>
            </TooltipProvider>
        </>
    );
}